export const PAGE_RSM_PUBLICATIONS = "/rsm/publications";
export const PAGE_RSM_MY_PUBLICATIONS = "/rsm/my-publications";
export const PAGE_RSM_REPORTING = "/rsm/reporting";
export const PAGE_RSM_SETTINGS = "/rsm-settings";
export const PAGE_RSM_VIEW_MY_PUBLICATION = "/rsm/view-my-publication";
export const PAGE_RSM_VIEW_PUBLICATION = "/rsm/view-publication";
export const PAGE_RSM_NEW_PUBLICATION = "/rsm/publications/new";
export const PAGE_RSM_EDIT_PUBLICATION = "/rsm/publications/edit";
export const PAGE_RSM_DASHBOARD = "/rsm/dashboard";
